import { api } from '@/redux/api/api';
import { DispatchOptimisticPatchHandler } from '@/redux/types/dispatch-optimistic-patch-handler';
import { removeItemRecipe } from '@/redux/utils/remove-item-recipe';
import { DeleteUserQueryArg } from '../types/query-arg';

export const dispatchOptimisticPatchDeleteUser: DispatchOptimisticPatchHandler<
  DeleteUserQueryArg
> = (queryArg, { dispatch }) => {
  const patch = dispatch(
    api.util.updateQueryData(
      'getUsers',
      undefined,
      removeItemRecipe('id', queryArg.id),
    ),
  );

  return { patch };
};
